module.exports = __webpack_public_path__ + "img/甲烷.36f80ea6.png";